import PriceData from '../model/price-data';

export function getParameterByName(name: string, url = window.location.href): string | undefined {
  // eslint-disable-next-line no-param-reassign
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return undefined;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function decodeHTML(htmlString: string): string {
  const text = document.createElement('textarea');
  text.innerHTML = htmlString;
  return text.value;
}

export function updateLocation(value: string): void {
  window.history.replaceState({ path: value }, '', value);
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function removeBlankProperties(obj: any): any {
  const propNames = Object.getOwnPropertyNames(obj);
  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
      // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-unsafe-member-access
      delete obj[propName];
    }
  }
  return obj;
}

export function validateNumericValue(value: string): boolean {
  const numericRegex = new RegExp('^(0|[1-9][0-9]*)$');
  return numericRegex.test(value);
}

export function isEnterKeyEvent(event: KeyboardEvent): boolean {
  const { key } = event;
  return key === 'Enter' || key === '13';
}

export function encodeHTML(htmlString: string): string {
  const div = document.createElement('div');
  div.appendChild(document.createTextNode(htmlString));
  return div.innerHTML;
}

export function preventNonNumericInput(event: Event): void {
  if (event.type !== 'keypress') {
    // eslint-disable-next-line no-console
    console.warn('preventNonNumericInput() should be used with keypress event to allow backspace and other control characters');
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { key } = event as any;
  if (!validateNumericValue(key)) {
    event.preventDefault();
  }
}

export function formatDate(date: Date): string {
  return `${(`0${date.getDate()}`).slice(-2)}.${(`0${date.getMonth() + 1}`).slice(-2)}.${date.getFullYear()}`;
}

export function formatTime(date: Date): string {
  return `${(`0${date.getHours()}`).slice(-2)}:${(`0${date.getMinutes()}`).slice(-2)}:${(`0${date.getSeconds()}`).slice(-2)}`;
}

export function formatNumber(value: number, minimumFractionDigits = 0): string {
  return new Intl.NumberFormat('de-CH', { maximumFractionDigits: 2, minimumFractionDigits }).format(value);
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(value);
}

export function formatPrice(priceData: PriceData, showCurrencyCode: boolean): string {
  if (!priceData) {
    return '';
  }
  if (showCurrencyCode) {
    return `${priceData.currencyIso} ${priceData.formattedValue}`;
  }
  return priceData.formattedValue;
}

export function formatIsoWeek(date: Date): string {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  return `${date.getFullYear()}-${$.datepicker.iso8601Week(date) as number}`;
}

export function anyQueryParameterExists(): boolean {
  return !!window.location.search.length;
}

export function getFacetValueFromQuery(name: string): string | undefined {
  const url = new URLSearchParams(window.location.search);
  const facetQuery = url.get('q');
  if (!facetQuery) {
    return undefined;
  }

  const queryTokens = facetQuery.split(':');
  const index = queryTokens.indexOf(name);
  if (index < 0) {
    return undefined;
  }
  return queryTokens[index + 1];
}
